import {
  chakra, Checkbox, Flex, useDisclosure
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import * as React from "react";
import { useState } from "react";
import { ConfirmationDialog } from "../../../components/ConfirmationDialog";
import { useTranslation } from "react-i18next";
import { QuestionsVirtualizedList } from "./components";
import { CSRD_QUESTION_COMPLETED } from "../helpers";

function CSRDTopicQuestions({
                              currentElement,
                              tabKey,
                              callMethod,
                              isPreview
                            }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "csrd.questionnaire"
  });
  const formId = `navForm${tabKey}`;

  const getFormDefaultValues = () => {
    const defaultValues = {};
    if (currentElement?.answers?.length > 0) {
      currentElement?.answers.forEach(answerObj => {
        defaultValues[answerObj.id] = {
          notApplicable: answerObj.notApplicable ?? false,
          answer: answerObj.answer ?? "",
          source: answerObj.source ?? "",
          comment: answerObj?.comment ?? ""
        };
        if (answerObj?.status === CSRD_QUESTION_COMPLETED) {
          defaultValues[answerObj.id].status = true;
        }
      });
    }
    return defaultValues;
  };

  const formDefaultValues = getFormDefaultValues();

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    watch
  } = useForm({
    defaultValues: formDefaultValues
  });

  const onSubmit = (data) => {
    const questions = [];

    Object.keys(data).forEach(id => {
      questions.push({
        ...data[id],
        id,
        topic: currentElement?.topic,
        notApplicable: data[id].notApplicable ?? false
      });
    });

    if (!isPreview) {
      callMethod(questions);
      reset(data);
    }
  };

  const [allUncompletedAreNotApplicable, setAllUncompletedAreNotApplicable] = useState(false);
  const [allAnsweredAreCompleted, setAllAnsweredAreCompleted] = useState(false);
  const { isOpen: isConfirmDialogOpen, onOpen: onConfirmDialogOpen, onClose: onConfirmDialogClose } = useDisclosure();

  const setUncompletedAsNotApplicable = () => {
    setAllUncompletedAreNotApplicable(true);
    currentElement.questions
      .filter(q => watch(`${q.id}.status`) !== true)
      .forEach(q => {
        setValue(`${q.id}.notApplicable`, true);
        setValue(`${q.id}.answer`, "n/a");
        setValue(`${q.id}.source`, "n/a");
      });
    handleDialogClose(true);
  };

  const handleDialogClose = () => {
    onConfirmDialogClose();
  };

  const setAnsweredAsCompleted = (e) => {
    if (e.target.checked) {
      currentElement.questions
        .filter(q => {
          return watch(`${q.id}.answer`) !== null && typeof watch(`${q.id}.answer`) !== "undefined" && watch(`${q.id}.answer`) !== "" &&
            watch(`${q.id}.source`) !== null && typeof watch(`${q.id}.source`) !== "undefined" && watch(`${q.id}.source`) !== "" &&
            !watch(`${q.id}.notApplicable`);
        })
        .forEach(q => {
          setValue(`${q.id}.status`, true);
        });
    }
    setAllAnsweredAreCompleted(e.target.checked);
  };

  return (
    <chakra.form
      id={formId}
      onSubmit={handleSubmit(onSubmit)}
      flexGrow="1"
      overflowY="auto"
      paddingBlockEnd="4"
      paddingInline="2"
      marginInline="-2"
      height="100%"
    >
      <Flex flexFlow="column" gap={1}>
        <Checkbox
          isChecked={allAnsweredAreCompleted}
          onChange={(e) => setAnsweredAsCompleted(e)}
          width="max-content" maxWidth="100%"
          colorScheme={"customScheme"}
          fontWeight={"500"}
          marginBlockEnd={2}
          isDisabled={isPreview}
        >
          {t("markAllAnswered")}
        </Checkbox>
        <Checkbox
          isChecked={allUncompletedAreNotApplicable}
          onChange={(e) => {
            if (e.target.checked) {
              onConfirmDialogOpen();
            } else {
              setAllUncompletedAreNotApplicable(e.target.checked);
            }
          }}
          width="max-content" maxWidth="100%"
          colorScheme={"customScheme"}
          fontWeight={"500"}
          marginBlockEnd={2}
          isDisabled={isPreview}
        >
          {t("markAsNotApplicable")}
        </Checkbox>
      </Flex>
      {currentElement && currentElement?.questions?.length > 0 ?
        <QuestionsVirtualizedList
          items={currentElement.questions}
          questionnaireYear={currentElement.year}
          comments={currentElement.comments}
          assignee={currentElement.assignee}
          register={register}
          control={control}
          setValue={setValue}
          isPreview={isPreview}
        /> : null}

      <ConfirmationDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleDialogClose}
        onConfirm={setUncompletedAsNotApplicable}
        headerText={t("confirmationDialogHeader")}
        confirmationText={t("confirmationQuestion")}
      />
    </chakra.form>
  );
}

export default CSRDTopicQuestions;